import React, { useEffect, useState } from "react";
import { Modal, DatePicker, Table, Button, Alert, message, Typography } from 'antd';
import axios from 'axios';
import { URL_PAGAMENTO } from '../../config/urls';
import moment from 'moment';

export default function TabelaParcelasCobranca(props) {

  const [parcelas, setParcelas] = useState([]);
  const [alterarDataParcela, setAlterarDataParcela] = useState(false);
  const [dataMaxPagto, setDataMaxPagto] = useState(null);
  const [dataMinPagto, setDataMinPagto] = useState(null);
  const [novaDataPagamento, setNovaDataPagamento] = useState(null);
  const [parcelaInicialAlteracao, setParcelaInicial] = useState(0);
  const [alterandoParcelas, setAlterandoParcelas] = useState(false);
  const { Text } = Typography;

  useEffect(() => {
    getParcelas();
    console.log("buscar parcelas")
  }, []);

  const getParcelas = () => {
    axios.get(`${URL_PAGAMENTO}/pedido/parcelas/${props.pedidoID}`, {
      headers: {
        "Authorization": "Bearer " + sessionStorage.getItem("tokenPagamento")
      }
    })
      .then((response) => {
        setParcelas(response.data);
      })
      .catch((error) => {
        console.log("Sem parcelas disponíveis (pagamento via boleto/Pix)");
        setParcelas([]);
      })
      .finally(() => {
        setAlterandoParcelas(false);
      });
  }

  const setUTCHour = (data) => {
    return new Date(data).setUTCHours(3);
  }

  const calcularDataMaxPagto = (qtdParcelasAEditar, dtParcela) => {
    let dataMaxima = new Date(setUTCHour(props.dataMaxPagto));
    const diasRemover = (30 * qtdParcelasAEditar) + 60;
    dataMaxima.setDate(dataMaxima.getDate() - diasRemover);
    setDataMaxPagto(dataMaxima);
    setDataMinPagto(new Date(setUTCHour(new Date())));
    setNovaDataPagamento(moment(dtParcela));
  }

  function splitReverseJoin(split, join, data) {
    return data.split(split).reverse().join(join);
  }

  const alterarDataPagto = () => {
    if (!novaDataPagamento) return;
    setAlterandoParcelas(true);
    // AntD DatePicker returns a moment object (v4) or dayjs (v5). Assuming moment based on imports or dayjs if v5. 
    // The original code used vanilla Date logic.
    // Let's assume moment for safety or convert standard JS date.
    // The original package.json likely has moment.
    const dateObj = novaDataPagamento.toDate();

    let mes = (dateObj.getUTCMonth() + 1);
    mes = mes < 10 ? "0" + mes : mes;
    axios.put(`${URL_PAGAMENTO}/alterar-data-cobranca`, {
      pedidoID: props.pedido.pedido,
      parcelaInicial: parcelaInicialAlteracao,
      dataInicial: dateObj.getUTCFullYear() + "-" + mes + "-" + dateObj.getUTCDate()
    }, {
      headers: {
        "Authorization": "Bearer " + sessionStorage.getItem("tokenPagamento")
      }
    })
      .then((response) => {
        message.success("Data de pagamento alterada");
        setParcelas(response.data);
        setNovaDataPagamento(null);
        setAlterarDataParcela(false);
      })
      .catch((error) => {
        message.error("Erro ao alterar a data de pagamento. Tente novamente mais tarde!");
      })
      .finally(() => {
        setAlterandoParcelas(false);
      });
  }

  const columns = [
    {
      title: 'Nº',
      key: 'index',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
    },
    {
      title: 'Data de vencimento',
      dataIndex: 'dataVencimento',
      key: 'dataVencimento',
      render: (text, record, index) => (
        <>
          {splitReverseJoin("-", "/", text)}
          {!record.pago && props.pedido?.cobranca?.parcelas && (
            <Button type="link" onClick={() => {
              setParcelaInicial(index + 1);
              calcularDataMaxPagto(props.pedido.cobranca.parcelas.length - index, record.dataVencimento);
              setAlterarDataParcela(true);
            }}>
              Alterar data
            </Button>
          )}
        </>
      )
    },
    {
      title: 'Status pagamento',
      dataIndex: 'pago',
      key: 'pago',
      render: (pago) => pago ? <Text type="success">Pago</Text> : <Text type="warning">Pendente</Text>
    }
  ];

  return (
    <>
      {parcelas && parcelas.length > 0 && (
        <Table
          dataSource={parcelas}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          bordered
          style={{ marginTop: 20, marginBottom: 20 }}
        />
      )}

      <Modal
        title="Alteração da data de pagamento"
        visible={alterarDataParcela}
        onCancel={() => setAlterarDataParcela(false)}
        footer={[
          <Button key="back" onClick={() => setAlterarDataParcela(false)}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={alterandoParcelas} onClick={alterarDataPagto}>
            Alterar
          </Button>,
        ]}
      >
        <Alert
          message="ATENÇÃO:"
          description={
            <>
              <p>Escolha a data da parcela no campo abaixo. Você poderá escolher uma data até o dia <strong>{dataMaxPagto !== null ? dataMaxPagto.getUTCDate() + "/" + (dataMaxPagto.getUTCMonth() + 1) + "/" + dataMaxPagto.getUTCFullYear() : ''}</strong>.</p>
              <p>OBS: Caso você tenha mais de uma parcela, elas serão agendadas para pagamento nos meses seguintes.</p>
            </>
          }
          type="info"
          showIcon
          style={{ marginBottom: 20 }}
        />
        <label><span style={{ color: 'red' }}>*</span> Data da parcela</label>
        <DatePicker
          style={{ width: '100%' }}
          format="DD/MM/YYYY"
          value={novaDataPagamento}
          onChange={(date) => setNovaDataPagamento(date)}
          disabledDate={(current) => {
            // Can't select days not in range
            // Logic: >= dataMin, <= dataMax
            const currentTimestamp = current.valueOf();
            // We need to convert dataMin and dataMax to comparables.
            // dataMinPagto and dataMaxPagto are Date objects.
            if (!dataMinPagto || !dataMaxPagto) return false;

            // Adjust to start of day for accurate comparison if needed, or just compare timestamps
            // current is a moment object usually in AntD v4.
            return currentTimestamp < dataMinPagto.getTime() || currentTimestamp > dataMaxPagto.getTime();
          }}
        />
      </Modal>
    </>
  );
}